module.exports = __webpack_public_path__ + "img/ipdzfw_icon.a1edcfeb.png";